module.exports = __webpack_public_path__ + "img/Beginning-Title-SVG.a226f379.svg";